module.exports = __webpack_public_path__ + "img/usd-xrp.ff2f449a.png";